import { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import DownloadBtn from '../../../../../../Components/Buttons/DownloadBtn';
import { FormGroup } from '../../../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../../../_helpers/fetchWrapper';

function Summary({
  id,
  postEventId,
  postEvent,
  isCompleted,
  handlePostEventSummarySave,
  CAN_EDIT
}) {
  const intl = useIntl();
  const [summary, setSummary] = useState();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur'
  });

  useEffect(() => {
    if (postEvent) {
      setValue('actual_cost', postEvent.actual_cost);
      setValue('is_completed', postEvent.is_completed);
      setValue('summary', postEvent.remarks);
    }
  }, [postEvent]);

  const handleComplete = async (newData) => {
    let res;
    if (postEventId) res = await fetchWrapper.patch(`/event/post/${postEventId}/`, newData);
    else res = await fetchWrapper.post(`/event/post/`, newData);
    newData.id = res?.id;
    handlePostEventSummarySave(newData);
    toast.success(
      postEventId ? (
        <FormattedMessage id="successfully_created" />
      ) : (
        <FormattedMessage id="successfully_updated" />
      )
    );
  };

  const onSubmit = async (data) => {
    try {
      const newData = { ...data };

      newData.event = id;
      newData.remarks = JSON.stringify(summary);

      if (newData.is_completed) {
        Swal.fire({
          text: intl.formatMessage({ id: 'toIndicateEventIsCompleted' }),
          icon: 'warning',
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: intl.formatMessage({ id: 'button.submit' }),
          cancelButtonText: intl.formatMessage({ id: 'cancel' })
        }).then((result) => {
          if (result.isConfirmed) {
            handleComplete(newData);
          }
        });
      } else {
        handleComplete(newData);
      }
    } catch (e) {
      toast.error('Something went wrong');
    }
  };

  return (
    <div>
      <h4 className="text-primary mb-4">
        <FormattedMessage id="postEventActivities.summary" />
      </h4>
      <Form className="edit_post_event_activity" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <FormGroup
            label={intl.formatMessage({ id: 'actual_cost' })}
            className="form-control"
            type="number"
            id="actual_cost"
            error={errors}
            register={register}
            required={true}
            errorId="Actual_Cost"
            defaultValue={postEvent && postEvent.actual_cost}
            disabled={isCompleted || !CAN_EDIT}
          />
        </div>
        <div className="form-group">
          {console.log(postEvent?.remarks, 'postEvent?.remarks')}
          <FormGroup
            key={postEvent?.remarks}
            label={intl.formatMessage({ id: 'summary' })}
            className="form-control"
            id="remarks"
            type="textarea"
            register={register}
            error={errors}
            required={true}
            errorId="Remarks"
            placeholder={intl.formatMessage({ id: 'event-summary.placeholder' })}
            defaultValue={postEvent?.remarks}
            onChange={(e) => {
              setSummary(e.target.value);
            }}
            disabled={isCompleted || !CAN_EDIT}
          />
        </div>
        {CAN_EDIT && (
          <div className="alert alert-warning">
            <FormattedMessage id="eventFilesinstruction" />
          </div>
        )}
        <div className="mx-2 form-group d-flex">
          <label className="d-flex mt-2 flex-column" htmlFor="is_completed">
            <FormattedMessage id="isEventCompleted" />
            <span className="text-danger">
              {CAN_EDIT && (
                <>
                  (
                  <FormattedMessage id="toIndicateEventIsCompleted" />)
                </>
              )}
            </span>
          </label>
          <input
            className="ms-3"
            defaultChecked={postEvent && postEvent.is_completed}
            type="checkbox"
            id="is_completed"
            disabled={isCompleted || !CAN_EDIT}
            {...register('is_completed')}
          />
        </div>

        {isCompleted && (
          <div className="mx-2 mt-3 form-group d-flex mb-4">
            <label className="d-flex mt-2 d-flex" htmlFor="is_completed">
              <FormattedMessage id="postEventActivities.download_report" />
              <span className="mx-1">:</span>
            </label>
            <DownloadBtn apiUrl={`/report/each-event-list/?type=excel&event=${id}`} type="excel" />
          </div>
        )}
        {!isCompleted && CAN_EDIT && (
          <div className="d-flex w-100 justify-content-end">
            <Button type="submit">
              <FormattedMessage id="button.submit" />
            </Button>
          </div>
        )}
      </Form>
    </div>
  );
}

export default Summary;
